namespace TabAurous.ProductDevelopment {
    export namespace PDQuotationItemsSelectService {
        export const baseUrl = 'ProductDevelopment/PDQuotationItemsSelect';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<PDQuotationItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ProductDevelopment/PDQuotationItemsSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>PDQuotationItemsSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
